import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'wz-auto-unsubscribe',
  template: '',
  styles: [''],
  standalone: false,
})
export class AutoUnsubscribeComponent implements OnDestroy {
  protected destroy$: Subject<void> = new Subject<void>();

  constructor() {
    const func = this.ngOnDestroy;
    this.ngOnDestroy = () => {
      func.call(this);
      this.destroy$.next();
      this.destroy$.complete();
    };
  }

  ngOnDestroy() {}
}
